<!-- Restricted Products Modal -->
<p-dialog
  [visible]="visible()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '1025px': '100vw', '640px': '100vw' }"
  [style]="{ width: '25vw' }"
  styleClass="no-header-modal no-overflow-content"
  (onHide)="closePopup()"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <div
      class="p-3 md:py-3 md:px-4 flex align-items-center justify-content-between relative border-bottom-1 border-300"
    >
      <h2
        class="mb-0 text-sm"
        [innerHTML]="
          'ADMIN.COUPON.LIST_SERVICES_LBL'
            | translate: { count: (selectedServices | async).length }
        "
      ></h2>
      <div
        class="fa fa-times text-xl text-600 cursor-pointer"
        (click)="closePopup()"
      ></div>
    </div>
    <!-- Header -->

    <!-- Header -->
    <div
      class="py-2 md:py-3 md:px-4 px-2 flex align-items-center surface-50 relative border-bottom-1 border-300"
    >
      <div class="p-inputgroup inline-flex w-full mb-3 md:mb-0">
        <p-select
          [options]="services"
          styleClass="text-sm w-full"
          optionLabel="name_primary_language"
          [filter]="true"
          filterBy="name_primary_language"
          [placeholder]="'ADMIN.COUPON.SEARCH_ADD_PRODUCT' | translate"
          (onChange)="addService($event)"
        >
          <ng-template let-service pTemplate="item">
            <div class="country-item">
              <div>{{ service.name_primary_language }}</div>
            </div>
          </ng-template>
        </p-select>
      </div>
    </div>
    <!-- Header -->

    <!-- Content -->
    <div class="surface-50 text-sm py-2 border-bottom-1 border-300">
      @if (
        (selectedServices | async) && (selectedServices | async).length > 0
      ) {
        <div>
          <p-scrollPanel styleClass="w-full h-25rem">
            <!-- List Item -->
            @for (service of selectedServices | async; track service) {
              <div
                class="flex align-items-center justify-content-between p-3 border-bottom-1 border-300"
              >
                <div class="flex align-items-center justify-content-between">
                  <strong class="text-primary">{{
                    service.service_category_name
                  }}</strong>
                </div>
                <i
                  class="fa fa-trash-alt text-600 cursor-pointer ml-3"
                  (click)="removeService(service)"
                ></i>
              </div>
            }
            <!-- List Item -->
          </p-scrollPanel>
        </div>
      } @else {
        <div class="text-center p-5">
          <p>{{ 'ADMIN.COUPON.NO_SERVICES' | translate }}</p>
          <!-- <img src="/assets/img/empty-restrictions-img.svg" alt="No restricted clients added!" /> -->
          <img src="/assets/img/empty-restrictions-img.svg" alt="Image" />
        </div>
      }
    </div>
    <!-- Content -->
  </ng-template>
</p-dialog>
<!-- Restricted Products Modal -->
